<div style="height: 100%; width: 100%" (click)="select()">
  <img [title]="emoji.title" class="emoji-item" [style.maxWidth.px]="maxWidth" [src]="emoji.imageHost + emoji.image" />
</div>
